export default "__VITE_PUBLIC_ASSET__d088ca51__"